import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: `Nunito`,
    body: `Inter`,
    
  },
})

export default theme